// Format date to Israel timezone
export const formatDateInIsrael = (dateString, options = {}) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  
  return date.toLocaleDateString('he-IL', {
    timeZone: 'Asia/Jerusalem',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...options
  });
};

// Format date and time in Israel timezone
export const formatDateTimeInIsrael = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  
  return date.toLocaleString('he-IL', {
    timeZone: 'Asia/Jerusalem',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Get current date in Israel timezone
export const getTodayInIsrael = () => {
  const now = new Date();
  const israelDate = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Jerusalem' }));
  return israelDate.toISOString().split('T')[0];
};

// Get current datetime in Israel timezone
export const getNowInIsrael = () => {
  const now = new Date();
  return new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Jerusalem' }));
};
